<template>
    <div class="adaptive-image"
         :style="[{maxWidth: `${maxWidth}px`}, {maxHeight: `${maxHeight}px`}]"
         @click="$emit('click')">
        <div class="img-inner">
            <img ref="img"
                 v-if="url"
                 class="img"
                 :src="url"
                 alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdaptiveImage',
    props: {
        maxWidth: {
            type: Number,
            default: 248,
        },
        maxHeight: {
            type: Number,
            default: 160,
        },
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
        }
    },
    watch: {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.adaptive-image {
    display: flex;
    .img-inner {
        line-height: 0;
        max-width: inherit;
        max-height: inherit;
        .img {
            max-width: inherit;
            max-height: inherit;
            cursor: pointer;
            border-radius: 12px;
            object-fit: cover;
            transition: opacity 0.3s ease-in-out;
        }
    }
    .placeholder {
        background-color: #f0f0f0;
        border-radius: 12px;
        transition: all 0.3s ease-in-out;
    }
}
</style>